import React, { useCallback } from 'react';

import { apiContainer } from '@vlabs/api-bindings';
import { ButtonWithPermissions } from '@vlabs/monokit/shared/ui/button-with-permissions';
import { permissions } from '@vlabs/shared/config';
import { openConfirmPopup } from '@vlabs/uikit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

export function DeleteFaceWidget({ faceId }) {
  const { t } = useTranslation();
  const history = useHistory();

  const onSubmit = useCallback(async () => {
    const message = t('faces:confirm_delete_face');

    const onConfirm = async () => {
      const response = await apiContainer.lunaClient.faces.delete(faceId);

      if (response.status === 204) {
        toast.success(t('faces:face_deleted_success'));

        if (history.length > 2) {
          history.goBack();
        } else {
          history.push('/');
        }
      }
    };

    openConfirmPopup({
      title: t('faces:delete_face_title'),
      message,
      type: 'delete',
      onConfirm,
    });
  }, [history, t, faceId]);

  return (
    <ButtonWithPermissions
      data-testid="faceActionsDeleteButton"
      fullWidth
      kind="negative"
      onClick={onSubmit}
      permissions={{ rules: [permissions.face.deletion] }}
      variant="outlined"
    >
      {t('faces:delete_face')}
    </ButtonWithPermissions>
  );
}

DeleteFaceWidget.propTypes = {
  faceId: PropTypes.string,
};

DeleteFaceWidget.defaultProps = {
  faceId: undefined,
};
